"use client";

import { Collapsible as CollapsiblePrimitive } from "radix-ui";

/**
 * Single-section show/hide.
 *
 * Lighter than `<Accordion>` when you don't need item grouping or
 * single-open enforcement. Controlled via `open` + `onOpenChange` or
 * uncontrolled via `defaultOpen`.
 */
function Collapsible({ ...props }: React.ComponentProps<typeof CollapsiblePrimitive.Root>) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
}

/**
 * Toggles the collapsible. Use `asChild` to wrap your own button.
 */
function CollapsibleTrigger({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleTrigger>) {
  return <CollapsiblePrimitive.CollapsibleTrigger data-slot="collapsible-trigger" {...props} />;
}

/**
 * The hidden region. Animates open/closed via Radix.
 */
function CollapsibleContent({
  ...props
}: React.ComponentProps<typeof CollapsiblePrimitive.CollapsibleContent>) {
  return <CollapsiblePrimitive.CollapsibleContent data-slot="collapsible-content" {...props} />;
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
